"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function NetworkHub(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M12 1c1.06 0 1.93.83 1.99 1.88l4.91 2.45c.33-.21.71-.33 1.1-.33 1.1 0 2 .9 2 2 0 .71-.38 1.37-1 1.73v6.54c.62.36 1 1.02 1 1.73 0 1.1-.9 2-2 2-.39 0-.77-.12-1.1-.33l-4.91 2.45A1.988 1.988 0 0 1 12 23c-1.06 0-1.93-.83-1.99-1.88L5.1 18.67c-.33.21-.71.33-1.1.33-1.1 0-2-.9-2-2 0-.71.38-1.37 1-1.73V8.73C2.38 8.37 2 7.71 2 7c0-1.1.9-2 2-2 .39 0 .77.12 1.1.33l4.91-2.45A1.987 1.987 0 0 1 12 1zm1.1 3.67a.277.277 0 0 1-.1.05v3.41A3.696 3.696 0 0 0 12 8c-.35 0-.68.04-1 .13V4.72a.277.277 0 0 1-.1-.05L6.04 7.09 9.25 9.1a3.98 3.98 0 0 0-1.07 1.7L5 8.81v6.38l3.18-1.99c.21.66.58 1.24 1.07 1.7l-3.21 2.01 4.86 2.42c.03-.02.06-.04.1-.05v-3.41c.32.09.65.13 1 .13s.68-.04 1-.13v3.41c.04.01.07.03.1.05l4.86-2.42-3.21-2.01c.49-.46.86-1.04 1.07-1.7L19 15.19V8.81l-3.18 1.99a3.98 3.98 0 0 0-1.07-1.7l3.21-2.01zM12 10c.204 0 .4.028.586.084l.182.065.172.081c.02.02.04.03.06.04.28.16.52.4.7.67.18.29.29.63.3.99v.14a1.93 1.93 0 0 1-.013.178l-.03.174a2.006 2.006 0 0 1-.257.637c-.18.272-.42.511-.7.671-.02.01-.04.02-.06.04-.224.12-.474.195-.739.22l-.2.01a2.068 2.068 0 0 1-.768-.149l-.174-.082c-.019-.019-.04-.029-.059-.039-.28-.16-.52-.4-.7-.67-.18-.29-.29-.63-.3-.99v-.14c.01-.36.12-.7.3-.99l.115-.158.129-.149a2.15 2.15 0 0 1 .14-.136l.153-.122c.053-.038.107-.073.163-.105l.03-.016.03-.024c.055-.03.113-.057.172-.081l.182-.065c.185-.056.382-.084.586-.084z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = NetworkHub;
